import { CssBaseline } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/core/styles';
import axios from 'axios';
import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import InternationalizedApp from './InternationalizedApp/InternationalizedApp';
import store from './redux/store';
import theme from './theme';
import TelemetryProvider from './ApplicationInsights/AppInsightsTelemetryProvider';
import { analyticsTelemetry } from './ApplicationInsights/AnalyticsTelemetry';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Window {
    AutoQuotes: {
      config: {
        quotesBaseUrl: string;
        apiBaseUrl: string;
        reportsBaseUrl: string;
        currencyPayScriptUrl: string;
        fortisScriptUrl: string;
        analyticsConnectionString?: string;
        fortisEnvironment: string;
      };
    };
  }
}

function App(): React.ReactElement {
  if (window.AutoQuotes && window.AutoQuotes.config) {
    axios.defaults.baseURL = window.AutoQuotes.config.quotesBaseUrl;
    axios.defaults.headers.get['Cache-Control'] = 'no-cache';
    axios.defaults.headers.get.Pragma = 'no-cache';
    if (window.AutoQuotes.config.analyticsConnectionString) {
      analyticsTelemetry.initialize(
        window.AutoQuotes.config.analyticsConnectionString
      );
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <BrowserRouter>
          <TelemetryProvider>
            <InternationalizedApp />
          </TelemetryProvider>
        </BrowserRouter>
      </Provider>
    </ThemeProvider>
  );
}

export default App;
